module.exports = __webpack_public_path__ + "static/media/file-block-alt.c1d5ae43.svg";